import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { DropdownContainer, DropdownOption } from "./styles";

class SmallDropdown extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onOptionClick: PropTypes.func.isRequired,
    onClickOutside: PropTypes.func,
    selectedOption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  dropdown = createRef();

  componentDidMount() {
    document.addEventListener('click', this.handleClick);
    document.addEventListener('touchend', this.handleClick);
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('touchend', this.handleClick);
  }

  handleClick = evt => {
    if (evt.type === 'touchend') this.isTouch = true;
    if (evt.type === 'click' && this.isTouch) return;
    const { onClickOutside } = this.props;

    const el = this.dropdown.current;
    const { y: dropdownY, x: dropDownX, height: dropDownHeight, width: dropDownWidth } = el.getBoundingClientRect();
    let contains;
    if(evt.type === 'touchend') {
      const { y: targetY, x: targetX } = evt.target.getBoundingClientRect();

      contains = targetY >= dropdownY && targetY <= (dropdownY + dropDownHeight) && targetX >= dropDownX && targetX <= (dropDownX + dropDownWidth);
    } else {
      const { y: targetY, x: targetX } = evt;
      contains = targetY > dropdownY && targetY < (dropdownY + dropDownHeight) && targetX > dropDownX && targetX < (dropDownX + dropDownWidth);
    }

    if (el && !contains && onClickOutside) onClickOutside();
  };

  render() {
    const { children, onOptionClick, selectedOption } = this.props;

    return (
      <DropdownContainer onClick={onOptionClick} ref={this.dropdown}>
        {React.Children.map(children, child => (
          <li>
            <DropdownOption
              type="button"
              name={child.props.name}
              isActive={selectedOption === child.props.name}
            >{child.props.children}
            </DropdownOption>
          </li>
        ))}
      </DropdownContainer>
    );
  }
}

export default SmallDropdown;
